import { VisuallyHidden } from '@inflearn/ds-react';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { GetServerSidePropsContext } from 'next/types';
import qs from 'query-string';

import {
  API_ENDPOINT,
  type GetCertificateDetailResponse,
  fetchClientApiV1CourseCertificatesDetail,
} from '../../../resources/@types/courseSchema';
import CertificateLayout from '../../components/layout/CertificateLayout';
import { Certificate, getCertificateQueries } from '../../components/pages/certificate/Certificate';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const queryClient = new QueryClient();
    const locale = context.locale as string;
    const params = { ...getCertificateQueries(context.query.id as string), lang: locale };
    const response = await fetchClientApiV1CourseCertificatesDetail(
      qs.stringifyUrl(
        {
          url: API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_DETAIL,
          query: params,
        },
        {
          skipEmptyString: true,
        },
      ),
    );
    await queryClient.fetchQuery(
      [API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_DETAIL, params],
      () => response,
    );

    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
        lang: locale,
        certificateResponse: response,
        dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      },
    };
  } catch (_error) {
    return {
      notFound: true,
      props: {},
    };
  }
}

interface Props {
  certificateResponse: GetCertificateDetailResponse;
}

export default function CertificatePage(props: Props) {
  const { t } = useTranslation();

  return (
    <CertificateLayout
      courseTitle={props.certificateResponse?.data?.title}
      meta={{
        title: '메타_수료증상세_제목',
      }}
    >
      <VisuallyHidden>
        <h1>{t('수료증_상세페이지')}</h1>
      </VisuallyHidden>
      <Certificate certificateResponse={props.certificateResponse} />
    </CertificateLayout>
  );
}
